import { DEFAULT_LOCALE, SupportedLocale } from "@granular/fabric3-definitions";
import { useMemo } from "react";

const getBrowserLocale = (): SupportedLocale | undefined => {
  if (!navigator) {
    return undefined;
  }
  try {
    const candidate = navigator.languages
      .map((l) => {
        let locale = l;
        /**
         * The CI env sets locale to things like "en-US@posix". Intl doesn't like that so we strip
         * out any "@" extensions.
         */
        locale = locale.split("@")[0] ?? "";
        return locale.trim().replace("_", "-"); // Prefer dashes
      })
      // Use Intl to canonicalize the locale (e.g. "en-us" to "en-US")
      .map((l) => Intl.getCanonicalLocales(l)[0])
      // Make sure the string exists and has a dash. (Intl is ok with things like "en")
      .find((l) => l?.includes("-"));
    return candidate as SupportedLocale | undefined;
  } catch (error) {
    // Intl.getCanonicalLocales can throw on invalid locales
    console.error(error);
    return undefined;
  }
};

const getURLLocale = (): SupportedLocale | undefined => {
  const hostname = location.hostname;
  const domainRegion = hostname.split(".")[0];
  switch (domainRegion) {
    case "us": {
      return "en-US";
    }
    case "ca": {
      return "en-CA";
    }
    case "br": {
      return "pt-BR";
    }
    default: {
      return undefined;
    }
  }
};

export const useSSOLocale = (): SupportedLocale => {
  const locale = useMemo(() => {
    return getBrowserLocale() ?? getURLLocale() ?? DEFAULT_LOCALE;
  }, []);
  return locale;
};
